import _ from "lodash";

// converts old database values to current values
const backport = (element) => {
  let options = { ...element.options };

  let buttonBorderWidth = options["button-border-width"];
  if (buttonBorderWidth && buttonBorderWidth.indexOf("px") > -1) {
    options["button-border-width"] = buttonBorderWidth.replace("px", "");
  }
  return options;
};

export const buildSurveyFieldStylesheet = (
  builder,
  device,
  cta,
  element,
  variant,
  field
) => {
    let options = backport(element);

    let borderRadius;
    if (options["button-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["button-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["button-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["button-radius"] == "custom") {
      borderRadius = "";
      borderRadius += (options["button-radius-top-left"] || 0) + `px `;
      borderRadius += (options["button-radius-top-right"] || 0) + `px `;
      borderRadius += (options["button-radius-bottom-right"] || 0) + `px `;
      borderRadius += (options["button-radius-bottom-left"] || 0) + `px`;
    }

    let fontFamily = options["field-font"] || undefined;

    let fontWeight;
    if (
      options["field-font-weight"] &&
      options["field-font-weight"] !== "theme"
    ) {
      fontWeight = options["field-font-weight"];
    } else if (
      options["field-font-weight"] == "theme" &&
      variant.options["field-font-weight"]
    ) {
      fontWeight = variant.options["field-font-weight"];
    }

    let fontSize;
    if (options["field-font-size"]) {
      fontSize = options["field-font-size"];
    }

    let boxShadow;
    let boxShadowHover;

    if (options["button-shadow"] == "None") {
      boxShadow = "none";
    }

    if (options["button-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["button-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["button-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["button-shadow-horizontal-distance"]
          ? `${element.options["button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["button-shadow-vertical-distance"]
          ? `${element.options["button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["button-shadow-blur-radius"]
          ? `${element.options["button-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["button-shadow-spread-radius"]
          ? `${element.options["button-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadowHover =
        boxShadow +
        (element.options["button-hover-shadow-color"]
          ? element.options["button-hover-shadow-color"]
          : element.options["button-shadow-color"]
          ? element.options["button-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      boxShadow +=
        (element.options["button-shadow-color"]
          ? element.options["button-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      boxShadow +=
        element.options["button-shadow-inset"] == "true" ? "inset" : "";
    }

    let optionsDisplay;
    if (
      ["custom", "cf-survey-responsive"].includes(options["options-width"]) &&
      options["options-display"] == "table"
    ) {
      optionsDisplay =
        "display: table !important; margin-left: inherit !important; margin-right: inherit !important;";
    }

    let optionsMarginVertical;
    if (_.isNil(options["options-margin-bottom"]) == false) {
      optionsMarginVertical = options["options-margin-bottom"];
    } else if (
      ["cf-survey-regular", "cf-survey-full"].includes(
        options["options-width"]
      ) ||
      (options["options-width"] == "custom" &&
        options["options-display"] == "table")
    ) {
      optionsMarginVertical = 10;
    }

    let optionsMarginHorizontal;
    if (
      _.isNil(options["options-margin-left"]) == false &&
      options["options-width"] !== "cf-survey-full" &&
      options["options-display"] !== "table"
    ) {
      optionsMarginHorizontal = options["options-margin-left"];
    }

    let nextButtonBorderRadius = "";
    if (options["next-button-radius"] == "cf-not-rounded") {
      nextButtonBorderRadius = "0px";
    }
    if (options["next-button-radius"] == "cf-slightly-rounded") {
      nextButtonBorderRadius = "4px";
    }
    if (options["next-button-radius"] == "cf-fully-rounded") {
      nextButtonBorderRadius = "100px";
    }
    if (options["next-button-radius"] == "custom") {
      nextButtonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          nextButtonBorderRadius += `${
            _.isNil(options["next-button-radius-" + side]) == false
              ? options["next-button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let nextButtonBoxShadow;
    let nextButtonBoxShadowHover;

    if (options["next-button-shadow"] == "None") {
      nextButtonBoxShadow = "none";
    }

    if (options["next-button-shadow"] == "soft") {
      nextButtonBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["next-button-shadow"] == "hard") {
      nextButtonBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["next-button-shadow"] == "custom") {
      nextButtonBoxShadow = "";
      nextButtonBoxShadow +=
        (options["next-button-shadow-horizontal-distance"]
          ? `${options["next-button-shadow-horizontal-distance"]}px`
          : variant.options["next-button-shadow-horizontal-distance"]
          ? `${variant.options["next-button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (options["next-button-shadow-vertical-distance"]
          ? `${options["next-button-shadow-vertical-distance"]}px`
          : variant.options["next-button-shadow-vertical-distance"]
          ? `${variant.options["next-button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (options["next-button-shadow-blur-radius"]
          ? `${options["next-button-shadow-blur-radius"]}px`
          : variant.options["next-button-shadow-blur-radius"]
          ? `${variant.options["next-button-shadow-blur-radius"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (options["next-button-shadow-spread-radius"]
          ? `${options["next-button-shadow-spread-radius"]}px`
          : variant.options["next-button-shadow-spread-radius"]
          ? `${variant.options["next-button-shadow-spread-radius"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (options["next-button-shadow-color"]
          ? options["next-button-shadow-color"]
          : variant.options["next-button-shadow-color"]
          ? variant.options["next-button-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      nextButtonBoxShadowHover =
        nextButtonBoxShadow +
        (variant.options["next-button-hover-shadow-color"]
          ? variant.options["next-button-hover-shadow-color"]
          : variant.options["next-button-shadow-color"]
          ? variant.options["next-button-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      nextButtonBoxShadow +=
        variant.options["next-button-shadow-inset"] == "true" ? "inset" : "";
      nextButtonBoxShadowHover +=
        variant.options["next-button-shadow-inset"] == "true" ? "inset" : "";
    }

    let nextButtonPadding = options["next-button-padding"];
    let nextButtonPaddingValue = "";
    if (nextButtonPadding == "cf-button-small") {
      nextButtonPaddingValue = "padding: 8px 15px !important;";
    } else if (nextButtonPadding == "cf-button-regular") {
      nextButtonPaddingValue = "padding: 10px 20px !important;";
    } else if (nextButtonPadding == "cf-button-large") {
      nextButtonPaddingValue = "padding: 13px 20px !important;";
    }

    let nextButtonFontWeight;
    if (
      options["next-button-font-weight"] &&
      options["next-button-font-weight"] !== "theme"
    ) {
      nextButtonFontWeight = options["next-button-font-weight"];
    }

    let nextButtonWidth = options["next-button-width"];
    let nextButtonWidthValue = "";

    if (nextButtonWidth == "custom" && options["next-button-width-value"]) {
      nextButtonWidthValue = `max-width: ${options["next-button-width-value"]}px !important; width: 100% !important;`;
    } else if (nextButtonWidth == "cf-full-width") {
      nextButtonWidthValue = "min-width: 100% !important;";
    } else if (nextButtonWidth == "cf-button-mid") {
      nextButtonWidthValue = "min-width: 200px !important;";
    } else if (nextButtonWidth == "cf-button-slim") {
      nextButtonWidthValue = "min-width: 100px !important;";
    }

    // Button spacing from options
    let surveyButtonSpacingTop = 
      options["survey-button-spacing-top"] 
      ? options["survey-button-spacing-top"] 
      : variant.options["survey-button-spacing-top"] 
      ? variant.options["survey-button-spacing-top"] 
      : 0;

    let surveyButtonSpacingTopMobile = 
      options["survey-button-spacing-top-mobile"] 
      ? options["survey-button-spacing-top-mobile"] 
      : variant.options["survey-button-spacing-top-mobile"] 
      ? variant.options["survey-button-spacing-top-mobile"] 
      : null;

    let optionsWidth;
    if (options["options-width"] == "cf-survey-responsive") {
      optionsWidth = `auto`;
    } else if (options["options-width"] == "cf-survey-regular") {
      optionsWidth = `300px`;
    } else if (options["options-width"] == "cf-survey-full") {
      optionsWidth = `100%`;
    } else if (options["options-width"] == "custom") {
      optionsWidth = `${options["options-width-value"]}px`;
    }

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} #field_${field.id}.cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice {
  text-align: ${element.options["options-alignment"] ? element.options["options-alignment"] : 'center'} !important;
}

#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-small,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-regular,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-large,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next {
  ${options["next-button-color"] ? 'background: ' + options["next-button-color"] + '!important;' : ''}
  ${nextButtonWidthValue ? nextButtonWidthValue : ''}
  ${nextButtonPadding == 'custom' && options["next-button-padding-value"] ? `padding: ${options["next-button-padding-value"]}px 20px !important;` : nextButtonPaddingValue}
  ${options["next-button-font-size"] ? `font-size: ${options['next-button-font-size']}px !important;` : ''}
  ${nextButtonFontWeight ? `font-weight: ${nextButtonFontWeight} !important;` : ''}
  font-family: ${options["next-button-font-family"] ? options["next-button-font-family"] : ''} !important;
  ${options["next-button-text-color"] ? 'color: ' + options["next-button-text-color"] + ' !important;' : ''}
  ${options["next-button-border-style"] ? 'border-style: ' + options["next-button-border-style"] + ' !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width"]) == false ? 'border-width: ' + options["next-button-border-width"] + 'px !important;' : 'border-width: 1px !important;'}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-left"]) == false ? 'border-left-width: ' + options["next-button-border-width-left"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-left-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-right"]) == false ? 'border-right-width: ' + options["next-button-border-width-right"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-right-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-top"]) == false ? 'border-top-width: ' + options["next-button-border-width-top"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-top-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["next-button-border-width-bottom"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-bottom-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && options["next-button-border-color"] ? 'border-color: ' + options["next-button-border-color"] + ' !important;' : options["next-button-border-color"] ? 'border-color: ' + options["next-button-border-color"] + ' !important;' : ''}
  ${nextButtonBorderRadius ? 'border-radius: ' + nextButtonBorderRadius + ' !important;' : ''}
  ${nextButtonBoxShadow ? 'box-shadow: ' + nextButtonBoxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-small:hover,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-regular:hover,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-large:hover,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next:hover {
  ${options["next-button–hover-color"] ? 'background: ' + options["next-button–hover-color"] + ' !important;' : options["next-button-color"] ? 'background: ' + options["next-button-color"] + ' !important;' : ''}
  ${options["next-button–hover-text-color"] ? 'color: ' + options["next-button–hover-text-color"] + ' !important;' : options["next-button-text-color"] ? 'color: ' + options["next-button-text-color"] + ' !important;' : ''}
  ${options["next-button-hover-border-color"] ? 'border-color: ' + options["next-button-hover-border-color"] + ' !important;' : options["next-button-border-color"] ? 'border-color: ' +  options["next-button-border-color"] + ' !important;' : ''}
  ${nextButtonBoxShadowHover ? 'box-shadow: ' + nextButtonBoxShadowHover + ' !important;' : ''}
}

#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice {
  ${options["button-color"] ? 'background: ' + options["button-color"] + ' !important;' : ''}
  ${options["button-text-color"] ? 'color: ' + options["button-text-color"] + ' !important;' : ''}
  ${options["options-width"] == 'custom' && options["options-width-value"] ? `width: ${options["options-width-value"]}px !important;` : ''}
  ${options["button-size"] == 'custom' && options["button-size-value"] ? 'padding: ' + options["button-size-value"] + 'px 0px !important;' : ''}
  ${optionsDisplay ? optionsDisplay : ''}
  ${options["button-border-style"] ? 'border-style: ' + options["button-border-style"] + ' !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width"]) == false ? 'border-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-left"]) == false ? 'border-left-width: ' + options["button-border-width-left"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-left-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-right"]) == false ? 'border-right-width: ' + options["button-border-width-right"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-right-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-top"]) == false ? 'border-top-width: ' + options["button-border-width-top"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-top-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["button-border-width-bottom"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-bottom-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && options["button-border-color"] ? 'border-color: ' + options["button-border-color"] + ' !important;' : options["button-color"] ? 'border-color: ' + options["button-color"] + ' !important;' : ''}
  ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${_.isNil(optionsMarginVertical) == false ? 'margin-bottom: ' + optionsMarginVertical + 'px !important;' : ''}
  ${_.isNil(optionsMarginHorizontal) == false ? 'margin-left: ' + optionsMarginHorizontal + 'px !important;' : ''}
  ${_.isNil(optionsMarginHorizontal) == false ? 'margin-right: ' + optionsMarginHorizontal + 'px !important;' : ''}
  ${optionsWidth ? `width: ${optionsWidth} !important;` : ''}
  max-width: -webkit-fill-available !important;
  max-width: fill-available !important;
}

#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice:hover, #cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice:active {
  ${options["button–hover-color"] ? 'background: ' + options["button–hover-color"] + ' !important;' : options["button-color"] ? 'background: ' + options["button-color"] + ' !important;' : ''}
  ${options["button–hover-text-color"] ? 'color: ' + options["button–hover-text-color"] + ' !important;' : options["button-text-color"] ? 'color: ' + options["button-text-color"] + ' !important;' : ''}
  ${options["button-border-style"] !== "" && options["button-hover-border-color"] ? 'border-color: ' + options["button-hover-border-color"] + ' !important;' : options["button-border-color"] ? 'border-color: ' + options["button-border-color"] + ' !important;' : options["button-color"] ? 'border-color: ' + options["button-color"] + ' !important;' : ''}
  ${boxShadowHover ? 'box-shadow: ' + boxShadowHover + ' !important;' : ''}
}

#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice p,
#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice .cf-survey-label {
  ${fontFamily ? `font-family: ${fontFamily} !important;` : ''}
  ${fontWeight ? `font-weight: ${fontWeight} !important;` : ''}
  ${fontSize ? `font-size: ${fontSize}px !important;` : ''}
}

#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] {
  ${surveyButtonSpacingTop ? `margin-top: ${surveyButtonSpacingTop}px !important;` : ''}
}

#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next {
  ${options["options-width"] == 'custom' && options['options-display'] == 'table' && options["options-width-value"] ? 'min-width: ' + options["options-width-value"] + 'px !important;' : ''}
}
`;

    let fontSizeMobile;
    if (options["field-font-size-mobile"]) {
      fontSizeMobile = options["field-font-size-mobile"];
    }

    let nextButtonWidthMobile = options["next-button-width-mobile"];
    let nextButtonWidthValueMobile = "";

    if (nextButtonWidthMobile == "custom" && options["next-button-width-value-mobile"]) {
      nextButtonWidthValueMobile = `max-width: ${options["next-button-width-value-mobile"]}px !important; width: 100% !important;`;
    } else if (nextButtonWidthMobile == "cf-full-width") {
      nextButtonWidthValueMobile = "width: 100% !important; min-width: 100% !important; max-width: 100% !important;";
    } else if (nextButtonWidthMobile == "cf-button-mid") {
      nextButtonWidthValueMobile = "width: 300px !important; min-width: 200px !important; max-width: 300px !important;";
    } else if (nextButtonWidthMobile == "cf-button-slim") {
      nextButtonWidthValueMobile = "width: 100px !important; min-width: 100px !important; max-width: 100px !important;";
    }

    let optionsCustomWidthMobile = "";
    if (options["options-width-mobile"] && options["options-width-mobile"] !== "custom") {
      optionsCustomWidthMobile = "";
    } else if (options["options-width-mobile"] == "custom" && options["options-width-value-mobile"]) {
      optionsCustomWidthMobile = `${options["options-width-value-mobile"]}px`;
    }

    let optionsWidthMobile;
    if (options["options-width-mobile"] == "cf-survey-responsive") {
      optionsWidthMobile = `auto`;
    } else if (options["options-width-mobile"] == "cf-survey-regular" || (!options["options-width-mobile"] && options["options-width"] == "cf-survey-regular")) {
      optionsWidthMobile = `300px`;
    } else if (options["options-width-mobile"] == "cf-survey-full") {
      optionsWidthMobile = `100%`;
    } else if (options["options-width-mobile"] == "custom") {
      optionsWidthMobile = `${options["options-width-value-mobile"]}px`;
    }

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice p,
#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice .cf-survey-label {
  ${fontSizeMobile ? `font-size: ${fontSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-small,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-regular,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next.cf-button-large,
#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] .cf-survey-next {
  ${options["next-button-font-size-mobile"] ? `font-size: ${options['next-button-font-size-mobile']}px !important;` : ''}
  ${nextButtonWidthValueMobile ? nextButtonWidthValueMobile : ''}
}

#cta_${cta.id} .cf-survey-next-outer[data-field-id="${field.id}"] {
  ${surveyButtonSpacingTopMobile ? `margin-top: ${surveyButtonSpacingTopMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-survey-field[data-field-id="${field.id}"] .cf-survey-choice {
  ${optionsWidthMobile ? `width: ${optionsWidthMobile} !important;` : ''}
  max-width: -webkit-fill-available !important;
  max-width: fill-available !important;
}
`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};

export const buildSurveyVisualChoiceStylesheet = (
  builder,
  device,
  cta,
  element,
  variant,
  field_option
) => {
    let visualTypeFontSize;
    if (element.options["visual-type-font-size"]) {
      visualTypeFontSize = element.options["visual-type-font-size"];
    } else if (variant.options["visual-type-font-size"]) {
      visualTypeFontSize = variant.options["visual-type-font-size"];
    } else {
      visualTypeFontSize = "16";
    }

    let fontColor;
    if (element.options["visual-type-font-color"]) {
      fontColor = element.options["visual-type-font-color"];
    }

    let optionsAlignment;
    if (element.options["options-alignment"]) {
      optionsAlignment = element.options["options-alignment"];
    }

    let optionsImageWidth;
    if (element.options["options-image-width"]) {
      optionsImageWidth = element.options["options-image-width"];
    } else if (variant.options["options-image-width"]) {
      optionsImageWidth = variant.options["options-image-width"];
    } else {
      optionsImageWidth = "134";
    }

    let optionsImageHeight;
    if (element.options["options-image-height"]) {
      optionsImageHeight = element.options["options-image-height"];
    } else if (variant.options["options-image-height"]) {
      optionsImageHeight = variant.options["options-image-height"];
    }

    let surveyLabelLeftAligned = "";
    let surveyLabelCenterAligned = `margin: auto;`;
    let surveyLabelRightAligned = `margin-left: auto; padding-right: 5px;`;

    let visualTypePlacement =
      element.options["visual-type-placement"] ||
      variant.options["visual-type-placement"];

    let visualTypePlacementWidth;
    if (visualTypePlacement == "centered") {
      visualTypePlacementWidth = "100%";
    } else if (visualTypePlacement == "left") {
      visualTypePlacementWidth = `${parseInt(visualTypeFontSize) * 0.6}%`;
    }

    let imageContainerHeight;
    if (visualTypePlacement == "left") {
      imageContainerHeight = visualTypeFontSize * 1.3;
    } else if (optionsImageWidth) {
      imageContainerHeight = optionsImageWidth * 0.67;
    }

    // prettier-ignore
    const desktopStyles =
      `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-outer-box {
        align-items: center;
        justify-content: flex-start;
        display: flex;
        ${visualTypePlacement == "left" ? 'flex-wrap: nowrap;' : 'flex-wrap: wrap;'}
        ${visualTypePlacement == "left" ? 'gap: 15px;' : 'gap: 5px;'}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] {
        ${element.options["options-width"] == "cf-survey-regular" && element.options['options-display'] == 'inline-block' ? `display: inline-block !important; ${element.options["options-margin-left"] ? 'margin-bottom: 0px;' : 'margin-left: 17px !important; margin-right: 17px !important;' }` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] div.cf-survey-choice-label {
        padding-left: 5px !important;
        padding-right: 5px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-box {
        ${visualTypePlacementWidth ? `width: ${visualTypePlacementWidth};` : ""}
        text-align: center !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-color {
        width: ${visualTypeFontSize * 1.5}px !important;
        height: ${visualTypeFontSize * 1.5}px !important;
        ${field_option.color ? `background: ${field_option.color};` : 'background: #000;' }
        line-height: 182% !important;
        border-radius: 50% !important;
        display: block !important;
        text-align: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-letter {
        ${visualTypeFontSize ? `font-size: ${visualTypeFontSize*0.77}px !important;` : ""}
        line-height: 182% !important;
        width: ${visualTypeFontSize * 1.5}px !important;
        height: ${visualTypeFontSize * 1.5}px !important;
        ${fontColor ? `border: 2px solid ${fontColor} !important;` : ''}
        ${fontColor ? `background-color: ${fontColor}14 !important;` : ''}
        ${fontColor ? `color: ${fontColor} !important;` : ""}
        border-radius: 50% !important;
        display: block !important;
        text-align: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type {
        ${visualTypeFontSize ? `font-size: ${visualTypeFontSize}px;` : ""}
        ${visualTypeFontSize ? `line-height: ${visualTypeFontSize * 1.3}px;` : ""}
        ${fontColor ? `color: ${fontColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-survey-choice-image-container {
        ${optionsImageWidth ? `width: ${optionsImageWidth}px !important;` : ""}
        ${optionsImageHeight ? `height: ${optionsImageHeight}px;` : imageContainerHeight ? `height: ${imageContainerHeight}px;` : ''}
        ${visualTypePlacement != "left" ? 'margin: 10px;' : ''}
        max-width: 100%;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-label {
        ${optionsAlignment === "left" ? surveyLabelLeftAligned : optionsAlignment === "right" ? surveyLabelRightAligned : surveyLabelCenterAligned}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .svg-inline--fa {
        display: var(--fa-display, inline-block);
        height: 1em;
        overflow: visible;
      }`;

    let optionsImageWidthMobile;
    if (element.options["options-image-width-mobile"]) {
      optionsImageWidthMobile = element.options["options-image-width-mobile"];
    } else if (variant.options["options-image-width-mobile"]) {
      optionsImageWidthMobile = variant.options["options-image-width-mobile"];
    } else {
      optionsImageWidthMobile = "134";
    }

    let optionsImageHeightMobile;
    if (element.options["options-image-height-mobile"]) {
      optionsImageHeightMobile = element.options["options-image-height-mobile"];
    } else if (variant.options["options-image-height-mobile"]) {
      optionsImageHeightMobile = variant.options["options-image-height-mobile"];
    }

    let visualTypeFontSizeMobile;
    if (element.options["visual-type-font-size-mobile"]) {
      visualTypeFontSizeMobile =
        element.options["visual-type-font-size-mobile"];
    } else if (variant.options["visual-type-font-size-mobile"]) {
      visualTypeFontSizeMobile =
        variant.options["visual-type-font-size-mobile"];
    } else if (element.options["visual-type-font-size"]) {
      visualTypeFontSizeMobile = element.options["visual-type-font-size"];
    } else if (variant.options["visual-type-font-size"]) {
      visualTypeFontSizeMobile = variant.options["visual-type-font-size"];
    } else {
      visualTypeFontSizeMobile = "16";
    }

    let fontColorMobile;
    if (element.options["visual-type-font-color-mobile"]) {
      fontColorMobile = element.options["visual-type-font-color-mobile"];
    }

    let visualTypePlacementMobile =
      element.options["visual-type-placement-mobile"] ||
      variant.options["visual-type-placement-mobile"] ||
      element.options["visual-type-placement"] ||
      variant.options["visual-type-placement"];

    let visualTypePlacementWidthMobile;
    if (visualTypePlacementMobile == "centered") {
      visualTypePlacementWidthMobile = "100%";
    } else if (visualTypePlacementMobile == "left") {
      visualTypePlacementWidthMobile = `${
        parseInt(visualTypeFontSizeMobile || visualTypeFontSize) * 0.6
      }%`;
    }

    let imageContainerHeightMobile;
    if (visualTypePlacementMobile == "left") {
      imageContainerHeightMobile =
        (visualTypeFontSizeMobile || visualTypeFontSize) * 1.3;
    } else if (optionsImageWidthMobile) {
      imageContainerHeightMobile = optionsImageWidthMobile * 0.67;
    }

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-outer-box {
        ${visualTypePlacementMobile == "left" ? 'flex-wrap: nowrap;' : 'flex-wrap: wrap;'}
        ${visualTypePlacementMobile == "left" ? 'gap: 15px;' : 'gap: 5px;'}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-box {
        ${visualTypePlacementWidthMobile ? `width: ${visualTypePlacementWidthMobile} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-color {
        ${visualTypeFontSizeMobile ? `font-size: ${visualTypeFontSizeMobile*0.77}px !important;` : ""}
        width: ${visualTypeFontSizeMobile * 1.5}px !important;
        height: ${visualTypeFontSizeMobile * 1.5}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type-letter {
        ${visualTypeFontSizeMobile ? `font-size: ${visualTypeFontSizeMobile*0.77}px !important;` : ""}
        ${fontColorMobile ? `border: 2px solid ${fontColorMobile} !important;` : ''}
        ${fontColorMobile ? `background-color: ${fontColorMobile}14 !important;` : ''}
        ${fontColorMobile ? `color: ${fontColorMobile} !important;` : ""}
        width: ${visualTypeFontSizeMobile * 1.5}px !important;
        height: ${visualTypeFontSizeMobile * 1.5}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-visual-type {
        ${visualTypeFontSizeMobile ? `font-size: ${visualTypeFontSizeMobile}px;` : ""}
        ${visualTypeFontSizeMobile ? `line-height: ${visualTypeFontSizeMobile * 1.3}px;` : ""}
        ${fontColorMobile ? `color: ${fontColorMobile} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-survey .cf-survey-choice[data-id="${field_option.id}"] .cf-survey-choice-image-container {
        ${optionsImageWidthMobile ? `width: ${optionsImageWidthMobile}px !important;` : ""}
        ${optionsImageHeightMobile ? `height: ${optionsImageHeightMobile}px;` : imageContainerHeightMobile ? `height: ${imageContainerHeightMobile}px;` : ''}

        ${visualTypePlacementMobile != "left" ? 'margin: 10px;' : ''}
      }
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
